export default {
  "supporters.detail.pageTitle": "サポーター",
  "supporters.detail.heading": "サポーター紹介",
  "supporters.detail.head.siteName": "LINK-J",

  "supporters.list.head.title": "サポーター紹介 | LINK-J",
  "supporters.list.head.description":
    "LINK-Jサポーターは、起業の経験をお持ちの方や、研究・開発、経営、法律・財務など様々な領域について卓越した知見を有する方などに就任いただいています。サポーターの方々にはLINK-Jが主催する各種イベントに参画していただくとともに、LINK-Jメンバー（特別会員）に対して個別の助言などを行っています。",
  "supporters.list.head.siteName": "LINK-J",
  "supporters.list.title": "サポーター",
  "supporters.list.heading.title": "サポーター紹介",
  "supporters.list.heading2.title":
    "LINK-Jの取り組みを支援するサポーターの方々",
  "supporters.list.heading.description":
    "LINK-Jでは、起業の経験をお持ちの方や、研究・開発、経営、法律・財務など様々な領域について卓越した知見を有する方などにサポーターに就任いただいています。サポーターの方々にはLINK-Jが主催する各種イベントに参画していただくとともに、LINK-Jメンバー（特別会員）に対して個別の助言などを行っていただきます。",

  "supporters.bbt.detail.pageTitle": "サポーター一覧（BBT） | LINK-J",
  "supporters.bbt.detail.head.siteName": "LINK-J",
  "supporters.bbt.list.head.title": "サポーター紹介 | LINK-J",
  "supporters.bbt.list.head.description":
    "創薬・医療領域のスタートアップ支援・コミュニティ活性化｜Blockbuster TOKYO サポーター",
  "supporters.bbt.list.head.ogDescription": "サポーター紹介",
  "supporters.bbt.list.head.siteName": "LINK-J",
  "supporters.bbt.list.title": "サポーター",
  "supporters.bbt.list.heading.title": "サポーター紹介",
  "supporters.bbt.list.heading2.title":
    "Blockbuster TOKYOの取り組みを促進するスタートアップ支援者",
  "supporters.bbt.list.heading.description":
    "創薬・医療系スタートアップの事業戦略や研究シーズの実用化に関するご相談など、事業戦略・資本政策・知財・法務・規制・マーケティング・海外展開・事業開発等の専門家であるサポーターに意見を求めることができます。サポーターをご指定いただくか、相談内容に応じて事務局で対応可能なサポーターを検討いたします。相談内容により必ずしもご希望に沿いかねる場合がございます。",
  "supporters.bbt.list.heading.description2":
    "サポーターへのご相談は contact@link-j.org まで 件名【BBTサポーターへのご相談】にてお問合せください。",
  "supporters.bbt.list.heading.description.note":
    "※初回無料、2回目以降のご相談は内容によって料金が発生する場合がございます。",
  "supporters.bbt.list.note1": "",
  "supporters.bbt.list.note2": "",

  "supporters.list.index.breadcrumbs": "サポーター紹介",
  "supporters.bbt.list.index.breadcrumbs": "サポーター紹介",
} as const;
